import React, { useEffect, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { getExcelDate } from "../../../utils/commonHelper";
import { useTranslation } from "react-i18next";

export const DynamicFormModal = ({
    show,
    handleClose,
    handleSubmit,
    inputParameters,
    noOfData,
}) => {
    const { t } = useTranslation();
    const [formData, setFormData] = useState({});

    const repeatedData = Array.from({ length: noOfData });

    const handleInputChange = (e, index) => {
        const { name, type, value, files } = e.target;

        if (noOfData && noOfData > 0) {
            // Handle repeated rows
            const updatedFormData = JSON.parse(JSON.stringify(formData));

            // Ensure the specific index exists
            if (!updatedFormData[index]) {
                updatedFormData[index] = {};
            }

            // Update the specific field
            if (type === "file") {
                updatedFormData[index][name] = [...files]; // Store multiple files
                updatedFormData[index][`${name}_name`] = files[0]?.name;
            } else if (type === "date") {
                updatedFormData[index][name] = value;
                updatedFormData[index][`${name + '_excel'}`] = getExcelDate(value);
            } else {
                updatedFormData[index][name] = value;
            }

            // Update state
            setFormData(updatedFormData);
        } else {
            // Handle single object
            if (type === "file") {
                setFormData({
                    ...formData,
                    [name]: [...files], // Store multiple files
                    [`${name}_name`]: files[0]?.name,
                });
            } else if (type === "date") {
                setFormData({
                    ...formData,
                    [name]: getExcelDate(value),
                });
            } else {
                setFormData({
                    ...formData,
                    [name]: value,
                });
            }
        }
    };


    useEffect(() => {
        if (noOfData && noOfData > 0) {
            setFormData(Array(noOfData).fill({}))
        } else {
            setFormData({})
        }
    }, [noOfData])


    return (
        <Modal size="xl" show={show} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>{t('extraInputModalTitle')}</Modal.Title>
            </Modal.Header>
            <form
                onSubmit={(e) => handleSubmit(e, formData)}
                method="post"
                encType="multipart/form-data"
            >
                <Modal.Body className="modal-scroll">
                    {repeatedData && repeatedData.length
                        ? repeatedData.map((_, rowIndex) => (
                            <div className="row mb-4" key={"input_row_" + rowIndex}>
                                {inputParameters && inputParameters.length && inputParameters.map((item, colIndex) => (
                                    <div
                                        className="col-md-4 col-sm-6 mb-3"
                                        key={"input_field_" + colIndex}
                                    >
                                        <label>
                                            {item.input_label}
                                            {item.is_mandatory === "1" && (
                                                <span style={{ color: "red" }}> *</span>
                                            )}
                                        </label>
                                        {item.input_type === "radio" ?
                                            <div className="flex-content">
                                                {item.option_paremeter.map((option, idx) => (
                                                    <div className='form-group custom-checkbox' key={item?.input_label + "_" + rowIndex + idx}>
                                                        <input type="radio"
                                                            name={
                                                                item?.input_label
                                                                    ? item?.input_label
                                                                        .replace(/\s+/g, "_")
                                                                        .toLowerCase()
                                                                    : ""
                                                            }
                                                            id={item?.input_label + "_" + rowIndex + idx}
                                                            value={option.option_value}
                                                            onChange={(e) => handleInputChange(e, rowIndex)}

                                                        />
                                                        <label htmlFor={item?.input_label + "_" + rowIndex + idx}>{option.option_label}</label>
                                                    </div>
                                                ))}
                                            </div>
                                            : item.input_type === "select" ? (
                                                <select
                                                    className="form-control element-style"
                                                    name={
                                                        item?.input_label
                                                            ? item?.input_label
                                                                .replace(/\s+/g, "_")
                                                                .toLowerCase()
                                                            : ""
                                                    }
                                                    placeholder={item?.input_label}
                                                    onChange={(e) => handleInputChange(e, rowIndex)}
                                                    required={item?.is_mandatory === "1"}
                                                >
                                                    <option value="">{item?.input_label}</option>
                                                    {item.option_paremeter.map((option, idx) => (
                                                        <option key={idx} value={option.option_value}>
                                                            {option.option_label}
                                                        </option>
                                                    ))}
                                                </select>
                                            ) : (
                                                <input
                                                    type={item.input_type}
                                                    className="form-control element-style"
                                                    name={
                                                        item?.input_label
                                                            ? item?.input_label
                                                                .replace(/\s+/g, "_")
                                                                .toLowerCase()
                                                            : ""
                                                    }
                                                    placeholder={item?.input_label}
                                                    onChange={(e) => handleInputChange(e, rowIndex)}
                                                    required={item?.is_mandatory === "1"}
                                                />)}
                                    </div>
                                ))}
                                {
                                    rowIndex === 0 && <>
                                        <div
                                            className="col-md-4 col-sm-6 mb-3"
                                            key={"input_field_email"}
                                        >
                                            <label>
                                                Email: <span style={{ color: "red" }}> *</span>
                                            </label>
                                            <input
                                                type="email"
                                                className="form-control element-style"
                                                name="email"
                                                placeholder="Enter Email"
                                                onChange={(e) => handleInputChange(e, rowIndex)}
                                                required
                                            />
                                        </div>
                                        <div
                                            className="col-md-4 col-sm-6 mb-3"
                                            key={"input_field_mobile_no"}
                                        >
                                            <label>
                                                Mobile No : <span style={{ color: "red" }}> *</span>
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control element-style"
                                                name="mobile_no"
                                                placeholder="Enter Mobile No"
                                                onChange={(e) => handleInputChange(e, rowIndex)}
                                                required
                                            />
                                        </div>
                                    </>
                                }
                            </div>
                        ))
                        : inputParameters && inputParameters?.length &&
                        inputParameters.map((item, index) => (
                            <div className="row my-3" key={index}>
                                <label className="form-label text-capitalize">
                                    {item.input_label}
                                    {item.is_mandatory === "1" && (
                                        <span style={{ color: "red" }}> *</span>
                                    )}
                                </label>
                                {item.input_type === "radio" ?
                                    <label className="form-check-label" key={index}>
                                        <div className="flex-content">
                                            {item.option_paremeter.map((option, idx) => (
                                                <div className='form-group custom-checkbox' key={item?.input_label + "_" + index + idx}>
                                                    <input type="radio"
                                                        name={
                                                            item?.input_label
                                                                ? item?.input_label
                                                                    .replace(/\s+/g, "_")
                                                                    .toLowerCase()
                                                                : ""
                                                        }
                                                        id={item?.input_label + "_" + index + idx}
                                                        value={option.option_value}
                                                        onChange={(e) => handleInputChange(e)}
                                                    />
                                                    <label htmlFor={item?.input_label + "_" + index + idx}>{option.option_label}</label>

                                                </div>
                                            ))}
                                        </div>
                                    </label>
                                    : item.input_type === "select" ? (
                                        <div className="col my-1">
                                            <select
                                                name={
                                                    item?.input_label
                                                        ? item.input_label.replace(/\s+/g, "_").toLowerCase()
                                                        : ""
                                                }
                                                placeholder={item.input_label}
                                                className="form-control element-style"
                                                onChange={(e) => handleInputChange(e)}
                                                required={item.is_mandatory === "1"}
                                            >
                                                {item.option_paremeter.map((op, idx) => (
                                                    <option value={op.option_value} key={idx}>
                                                        {op.option_value}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    ) : (
                                        <div className="col my-1">
                                            <input
                                                type={item.input_type}
                                                name={
                                                    item.input_label
                                                        ? item.input_label.replace(/\s+/g, "_").toLowerCase()
                                                        : ""
                                                }
                                                placeholder={item.input_label}
                                                className="form-control element-style"
                                                onChange={(e) => handleInputChange(e)}
                                                required={item.is_mandatory === "1"}
                                            />
                                        </div>
                                    )}
                            </div>
                        ))}

                </Modal.Body>
                <Modal.Footer>
                    <Button type="submit" variant="primary" className="h-btn">
                        Submit
                    </Button>
                </Modal.Footer>
            </form>
        </Modal>
    );
};
